import React from "react";
import { Navigate } from "react-router-dom";

// Redirect straight to /report — ReportPage handles loading & shimmer.

export const AccountStatusPage: React.FC = () => <Navigate to="/report" replace />;
